import Menubar from "components/Menubar/Menubar";
import React from "react";
import { customerUserMenu } from "constants/customerUserMenu";

const CustomerUserMenubar = () => {
  return <Menubar menu={customerUserMenu} color="primary" />;
};

export default CustomerUserMenubar;
